import React, { useState } from "react";
import Seo from "@/components/Seo";
import HelpHero from "@/components/marketing/help/HelpHero";
import HelpCategoryGrid from "@/components/marketing/help/HelpCategoryGrid";
import HelpFaqList from "@/components/marketing/help/HelpFaqList";
import HelpContactCTA from "@/components/marketing/help/HelpContactCTA";
import Reveal from "@/components/marketing/Reveal";

export default function HelpCentre() {
  const [search, setSearch] = useState("");

  const handleCategoryClick = (id) => {
    setSearch("");
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <div className="bg-[#f7f7f9]">
      <Seo title="Help Centre | Digital24" />
      <HelpHero search={search} onSearchChange={setSearch} />
      {!search && (
        <Reveal variant="card">
          <HelpCategoryGrid onCategoryClick={handleCategoryClick} />
        </Reveal>
      )}
      <HelpFaqList search={search} />
      <Reveal>
        <HelpContactCTA />
      </Reveal>
    </div>
  );
}